import {Component, HostBinding, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {Store} from '@ngrx/store';
import * as fromStore from '../../../../store';
import {HostingService} from "../../hosting/hosting.service";

@Component({
    selector: 'db-grant-access-copy-website-dialog',
    templateUrl: 'grant-access-copy-website-dialog.component.html',
    styleUrls: ['grant-access-copy-website-dialog.component.scss'],
    standalone: false
})
export class GrantAccessCopyWebsiteDialogComponent extends DialogComponent<null, boolean> implements OnInit {

  @Input() websiteId: number;
  @Input() websiteUrl: string;
  public accessGranted: boolean;

  @HostBinding('class.hidden') hideDialog: boolean = false;

  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {

  }


  public sendRequest(): void {
    this._hostingService.manual95Challenge(this.websiteId, this.websiteUrl);
    this.accessGranted = true;
  }

}
